
export default {
    props: ['hover', 'outline']
};
